import type { JSX } from 'react'
import { ChangePasswordDialog, type ChangePasswordCopy, type ChangePasswordResult } from '@speaking-coach/ui'
import { AdminApiError } from '../api/client'
import { authClient } from './auth-client'

const COPY: ChangePasswordCopy = {
  title: 'Change password',
  description: 'Enter your current password, then choose a new one. You stay signed in here.',
  currentLabel: 'Current password',
  newLabel: 'New password',
  newHint: 'Use at least 8 characters with letters and numbers.',
  confirmLabel: 'Confirm new password',
  submit: 'Change password',
  submitting: 'Changing…',
  cancel: 'Cancel',
  mismatch: 'The new passwords do not match.',
  currentIncorrect: 'Your current password is incorrect.',
  tooWeak: 'Use at least 8 characters with letters and numbers.',
  rateLimited: 'Too many attempts. Try again in a few minutes.',
  failed: 'Your password could not be changed. Check your connection and try again.',
  successTitle: 'Password changed',
  successBody: 'Other devices were signed out, and a confirmation was sent to your email address.',
  done: 'Done',
}

/** The operator menu's change-password dialog, in Admin's dense shape. */
export function AdminChangePasswordDialog({
  open,
  onOpenChange,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
}): JSX.Element {
  return <ChangePasswordDialog open={open} onOpenChange={onOpenChange} copy={COPY} onSubmit={changePassword} />
}

async function changePassword(currentPassword: string, newPassword: string): Promise<ChangePasswordResult> {
  try {
    await authClient.changePassword(currentPassword, newPassword)
    return 'ok'
  } catch (err) {
    if (!(err instanceof AdminApiError)) return 'failed'
    if (err.detail === 'current_password_incorrect') return 'current_incorrect'
    if (err.detail === 'password_too_weak') return 'too_weak'
    if (err.code === 'RATE_LIMITED') return 'rate_limited'
    return 'failed'
  }
}
